
<template>
  <div v-show="showModal">
    <div class="tutorial__overlay tutorial__overlay--dark font__color">
      <div class="game__form__translate">
        <div class="tutorial__page--center">
          <form class="game__form">
            <div style="margin-left:8px; margin-right:8px; padding-top: 2%;">
              <div class="raw search-top-up">
                <div>
                  <img :src="this.game.image.thumb.url" class="search-image">
                </div>
                <div class="search-form-position">
                  <h4 class="game_search_title game-tab-font">{{this.game.title}}で絞り込む</h4>
                </div>
                <div @click="closeModal()" class="search-batu-position"><img :src="batuImage" alt="batu"  class="search-batsu"></div>
              </div>
              <div class="game-seach-max">
                  <div v-for="(gameSkill, index) in this.gameDatas" :key="index">
                    <div class="raw" style="margin-bottom: 20px; padding-right: 8px;">
                      <div>
                        <h4 class="game-tab-font">
                          <div>
                            <div style="margin: 3px;">
                              <span>{{gameSkill[0].title}}</span>
                              <span style="display:flex; float:right; font-size:11px; color:#707070;}">※複数選択可能</span>
                            </div>
                          </div>
                          <div style="margin-top:20px;">
                              <div v-for="(game,gameIndex) in gameSkill[1]" :key="gameIndex"  style="border-bottom: 3px solid #f9f9f9; margin:5px;">
                                <label for="checkbox" class="profile-info-item__content" style="transform:translate(5px); font-size: 14px; font-weight: 400;">{{ game.skill }}</label>
                                <input type="checkbox" id="checkbox" v-model="searchSkilled" v-bind:value="{game_skill_id:game.game_skill_id, id:game.id}" style="display:flex; float:right; transform:translate(-8px);">
                              </div>
                          </div>
                        </h4>
                      </div>      
                    </div>
                  </div>
              </div>
                <input type="button"  @click="search()" value="完了" class="square-btn square-btn--primary game-search-submit">
            </div>
          </form>
        </div>
      </div>
    </div>
    <spinner-with-overlay v-if="isLoading" />
  </div>
</template>

<script>
import axios from 'packs/axios'
import Modal from 'packs/components/modal/modal.vue'
import SpinnerWithOverlay from 'packs/components/utility/spinner-with-overlay.vue'
import batuImage from 'packs/assets/images/common/batu.png'

export default {
  props: ['showModal','gameDatas','game'],
  components: {
    Modal, SpinnerWithOverlay
  },
  data: function () {
    return {
      batuImage,
      currentUser: "",
      searchSkilled:[],
      SelectedGames:[],
      isLoading: false
    }
  },
  methods: {
    exitModal: function(){
      var self = this;
      let params = {selectedGameSkills: this.selectedGameSkills , gameMesssage: this.gameMesssage ,validFlg: this.validFlg} 
      axios.post(`/api/v1/user_sale_games`, params)
      .then(function(res) {
        location.reload()
      })
      .catch(function(error) {
        console.log(error);
      });
      this.$emit('close-modal')
    },
    fetchCurrentUser: function(){
      var self = this;
      axios.get("/api/v1/current_user")
      .then(function(res) {
      }).catch((err) => {   
        this.isLoading = false;                 
      })
    },
    fetchSetSearchData: function(){
      var self = this;
      axios.get("/api/v1/user_sale_games/search_set")
      .then(function(res) {
        if(res.data.skill_detaills.length >= 0){
          self.searchSkilled = res.data.skill_detaills
          self.isLoading = false;  
        }
      }).catch((err) => {
      })
    },
    closeModal: function(){
      this.$emit('close-modal')
    },
    search: function(){
      var self = this;
      let params = {selectedGameSkills: this.searchSkilled }
      this.$emit('close-modal')
      self.isLoading = true;
      axios.get(`/api/v1/user_sale_games/search`, { params: params })
      .then(function(res) {
        self.isLoading = false;
        location.reload()
      })
      .catch(function(error) {
        console.log(error);
      });
    }
  },
  created () {
    this.fetchCurrentUser();
    this.fetchSetSearchData();
  },
  components: { Modal }
}
</script>

<style scoped>
  /* modal style */
  .modal-messages{
    padding: 0;
  }
  label{
    color: black;
  }
  input{
    color: black;
  }
  p{
    color: black;
    margin: 25px;
  }
  a{
    color: blue !important;
  }
  .game__form{
    background-color: #fff;
    width: 450px;
    height: auto;
  }
  .game__header{
    background-color:white;
    color: black;
  }

  .font__color{
    color: black;
  }
  .flex{
    display: flex;
    margin-left: 25px;
  }
  .image_size_change{
    cursor: pointer;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
  }
  .origin-form{
    font-size: 16px;
    min-height: 40px;
    background-color: #f7fafc;
    border: 0;
    border-radius: 4px;
    border: 1px solid #0a0a0a;
    width: 50%;
  }
  .origin-text-area{
    font-size: 13px;
    min-height: 40px;
    background-color: #f7fafc;
    border: 0;
    border-radius: 4px;
    border: 1px solid #0a0a0a;
    width: 95%;
    height: 150px;
  }

  .game_search_title{
    font-size: 18px;
    font-weight: 600;
    padding: 4px 0;
    align-items: center;
  }
</style>
